import { IPhone } from '@/Models/IPhone';
import { ITypedValidationResult } from '@/Models/IValidationResult';
import { BaseApiService } from './base-api-service';

class phoneService extends BaseApiService{
    
    public constructor() {
		super('phone/');
    }

	public async getByCaseId(caseId: number): Promise<IPhone[]> {
		return this.httpClient.get<IPhone[]>(`GetByCaseId/${caseId}`).then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
    }
    
	public async save(phone: IPhone): Promise<ITypedValidationResult<IPhone>> {
		return this.httpClient.post<ITypedValidationResult<IPhone>>("save", phone).then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
	}

	public async delete(phoneId: number): Promise<void> {
		return this.httpClient.delete<void>(`phone/${phoneId}`).then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
	}
}

export const PhoneService: phoneService = new phoneService();